import React from "react";
import { cn } from "../ClassName";

interface ButtonProps {
  children?: React.ReactNode;
  className?: string;
  onClick: (e?: React.SyntheticEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  dataCy?: string;
  transparent?: boolean;
}

const baseButtonStyles =
  "tw-inline-block tw-mb-0 tw-font-medium tw-text-center tw-align-middle tw-touch-manipulation tw-pointer tw-whitespace-nowrap tw-py-[6px] tw-px-[12px] tw-text-[14px] tw-rounded-md tw-select-none tw-cursor-pointer ";
const transparentBtnStyles =
  baseButtonStyles +
  `
  tw-border-[1px] tw-border-solid tw-border-blue-1 tw-bg-transparent tw-text-blue-1 focus:tw-text-blue-1 hover:tw-bg-blue-light-1 hover:tw-text-blue-1 active:tw-text-blue-1 tw-py-[6px] tw-px-[12px]
  `;
const defaultBtnStyles =
  baseButtonStyles +
  "tw-border-[1px] tw-border-solid tw-font-medium tw-bg-blue-2 tw-border-blue-2 tw-text-white focus:tw-text-white";

export function Button(props: ButtonProps) {
  return (
    <button
      className={cn(
        props.transparent ? transparentBtnStyles : defaultBtnStyles,
        props.className,
      )}
      onClick={(e) => props.onClick(e)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          props.onClick(e);
        }
      }}
      data-cy={props.dataCy !== undefined ? props.dataCy : null}
      disabled={props.disabled && true}
    >
      {props.children}
    </button>
  );
}

interface WebsiteButtonProps {
  children?: React.ReactNode;
  className?: string;
  primary?: boolean;
  disabled?: boolean;
}

export function WebsiteImageButton(props: WebsiteButtonProps) {
  return (
    <button
      className={cn(
        `tw-absolute tw-bottom-0 tw-left-0 tw-w-[100%] tw-border-0 tw-border-none tw-bg-blue-1 tw-py-[22px] tw-text-[18px] tw-font-bold tw-text-white`,
        props.className,
      )}
      style={{ fontFamily: "'DM Sans', sans-serif" }}
      disabled={!!props.disabled}
    >
      {props.children}
    </button>
  );
}

export function WebsiteButton(props: WebsiteButtonProps) {
  return (
    <button
      className={cn(
        `tw-rounded-md tw-border-0 tw-bg-blue-1 tw-px-[20px] tw-py-[12px] tw-text-[18px] tw-font-bold tw-text-white 440:tw-mb-[80px]`,
        props.className,
      )}
      style={{ fontFamily: "'DM Sans', sans-serif" }}
      disabled={props.disabled && true}
    >
      {props.children}
    </button>
  );
}

export function ProviderNoteButton(props: ButtonProps) {
  return (
    <Button
      className={cn(
        `tw-mr-4 tw-rounded-lg tw-px-[15px] tw-py-[10px] tw-font-dm-sans tw-font-[15px]`,
        props.className,
      )}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
}

export function SubmitButton(props: ButtonProps) {
  return (
    <Button
      className={cn(
        "tw-my-4 tw-block tw-h-20 tw-w-full !tw-text-3xl !tw-font-medium",
        props.className,
      )}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
}
